import { UPLOADS, ebook, pdf } from '@/content/ebookBuilder'
import type { Ebook } from '@/content/ebookBuilder'

export const added: Ebook = ebook(
  // Confirmed, and NOT what the title rule derives — the fourth one it has got
  // wrong, after `sustainability-innovation`,
  // `importance-of-measurement-for-transformation-success` and
  // `ai-in-fashion-retail`. The reference screenshots for this book's page came
  // from `digitopia.co/impact-labs/ebooks/leaders-guide-to-generative-ai/` on
  // 2026-08-28 and carry that address in their filenames, so the real slug
  // drops the leading "the".
  'leaders-guide-to-generative-ai',
  'The Leader’s Guide to Generative AI: Redefining What’s Possible in Business',
  `${UPLOADS}/2024/10/The-Leaders-Guide-to-Generative-AI-web-01-400x400.jpg`,
  {
    confirmed: true,
    download: pdf('d64f10d2-f3d8-462f-b24e-dff774ddb251-The Leader_s Guide to Generative AI.pdf'),
    // Designed as its own written page on 2026-08-28, the sixth after
    // Transform Better, Agentic AI, Sustainability Innovation, Measurement and
    // AI in Fashion Retail — so the card goes there and `prerender.tsx` skips
    // it, rather than generating this template over the top of it.
    href: '/en/impact-labs/ebooks/leaders-guide-to-generative-ai',
  },
)

/** Its place in the library grid — the order the imported index listed them. */
export const order = 8
